import { get, post, del, put, upload } from '@api/request';

export async function fetchPreference(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function persistPreference(
  { userService },
  authenticationToken,
  { userId, data },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/appraisal`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchYearEditable(
  { userService },
  authenticationToken,
  { year },
) {
  const url = `${userService}/appraisal/year/${year}/iseditable`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchElectronicDeliveryRequestsConfig(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/config`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateElectronicDeliveryRequestsConfig(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/config`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchElectronicDeliveryRequestsStatusConfigs(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfigs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertElectronicDeliveryRequestsStatusConfig(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfigs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchElectronicDeliveryRequestsStatusConfig(
  { userService },
  authenticationToken,
  { requestStatus },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfig/${requestStatus}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteElectronicDeliveryRequestsStatusConfig(
  { userService },
  authenticationToken,
  { requestStatus },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfig/${requestStatus}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function udpateElectronicDeliveryRequestsStatusConfig(
  { userService },
  authenticationToken,
  { requestStatus, payload },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfig/${requestStatus}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchElectronicDeliveryRequestsStatusStates(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/status/states`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setElectronicDeliveryRequestsStatusDefault(
  { userService },
  authenticationToken,
  { requestStatus },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequests/statusconfig/${requestStatus}/updatedefault`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchPortalSignUpRunPending(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignuprun/pending`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPortalSignUpEmailConfig(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignuprun/emailconfiguration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPortalEmailPreview(
  { userService },
  authenticationToken,
  { pID },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignup/${pID}/previewemail`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePortalSignUpEmailConfig(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignuprun/emailconfiguration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPortalSignUpNotificationRuns(
  { userService },
  authenticationToken,
  { page = 1, pageSize = 200 },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignupruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPortalSignUpNotificationRun(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignupruns`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function createPortalSignUpNotificationRunSingle(
  { userService },
  authenticationToken,
  { requestID },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignup/${requestID}/generate`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function fetchPortalSignUpNotificationRunRecords(
  { userService },
  authenticationToken,
  { runID, page = 1, pageSize = 200, filter = 'All' },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalsignuprun/${runID}/details?page=${page}&pageSize=${pageSize}&filter=${filter}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassUpdatePropertyJobs(
  { userService },
  authenticationToken,
  { page = 1, pageSize = 200 },
) {
  const url = `${userService}/appraisal/massupdatepropertyjobs?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassUpdateOtherJobs(
  { userService },
  authenticationToken,
  { runCategory, page = 1, pageSize = 200 },
) {
  const url = `${userService}/appraisal/massupdateotherjobs?runCategory=${runCategory}&page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassUpdateOtherJobRecords(
  { userService },
  authenticationToken,
  { runID, page = 1, pageSize = 200, filter = 'All' },
) {
  const url = `${userService}/appraisal/massupateotherjob/${runID}/records?page=${page}&pageSize=${pageSize}&filter=${filter}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertMassUpdatePropertyJobs(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/massupdatepropertyjobs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function insertMassUpdateOtherJobs(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/massupdateotherjobs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassUpdateOtherCategoryRunTypes(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/appraisal/massupdateother/categoryruntypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function massUpdateOtherValidateQuery(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/massupdateotherjob/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function uploadFiles(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/appraisal/uploadfiles`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchMassUpdatePropertyJobProperties(
  { userService },
  authenticationToken,
  { runID, filter },
) {
  const url = `${userService}/appraisal/massupatepropertyjob/${runID}/properties?${
    filter ? `filter=${filter}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPortalNotificationEmailConfig(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotification/emailconfiguration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePortalNotificationEmailConfig(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotification/emailconfiguration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPortalNotificationRuns(
  { userService },
  authenticationToken,
  { page = 1, pageSize = 20 },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPendingPortalNotifications(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/pending`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPendingNotificationRecords(
  { userService },
  authenticationToken,
  { page = 1, pageSize = 10 },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/pending/records?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPortalNotificationRunRecords(
  { userService },
  authenticationToken,
  { runID, page = 1, pageSize = 10, filter = 'All' },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/${runID}/details?page=${page}&pageSize=${pageSize}&filter=${filter}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPortalNotificationRun(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationruns`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function createNotificationRunSingle(
  { userService },
  authenticationToken,
  { requestID },
) {
  const url = `${userService}/appraisal/electronicdeliveryrequest/${requestID}/notification/send`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function fetchPortalNotificationAgentEmailConfig(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/agentemailconfiguration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePortalNotificationAgentEmailConfig(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/agentemailconfiguration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchPortalAgentEmailPreview(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/agentpreviewemail`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPortalNotificationPreviewEmail(
  { appraisalNoticeService },
  authenticationToken,
  { notificationId },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/electronicdeliveryportalnotification/${notificationId}/previewemail`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getEdrRunDetails(
  { userService },
  authenticationToken,
  { runId },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/${runId}`;
  const { body } = await get(authenticationToken, url);
  return body?.results?.[0] || null;
}

export async function createEDRNotificationsForMassFileImportRun(
  { userService },
  authenticationToken,
  { processID },
) {
  const url = `${userService}/prodigyappraisalnotices/electronicdeliveryportalnotificationruns`;
  const { body } = await post(authenticationToken, url, {
    processName: 'Mass File Import',
    processID,
  });
  return body;
}
